import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useCallback } from 'react';

import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  AddToWatchlistMutation,
  AddToWatchlistMutationVariables,
} from './__generated__/useAddToWatchlist.graphql.ts';

const ADD_TO_WATCHLIST_MUTATION = gql`
  mutation AddToWatchlistMutation(
    $watchlistId: ID!
    $printablePlayerIds: [ID!]!
  ) {
    addToWatchlist(
      input: {
        watchlistId: $watchlistId
        printablePlayerIds: $printablePlayerIds
      }
    ) {
      watchlist {
        slug
        id
        title
      }
    }
  }
` as TypedDocumentNode<AddToWatchlistMutation, AddToWatchlistMutationVariables>;

export const useAddToWatchlist = () => {
  const [mutate, { loading }] = useMutation(ADD_TO_WATCHLIST_MUTATION, {
    showErrorsWithSnackNotification: true,
  });

  const addToWatchlist = useCallback(
    async (watchlistId: string, printablePlayerIds: string[]) =>
      mutate({ variables: { watchlistId, printablePlayerIds } }),
    [mutate]
  );

  return {
    addToWatchlist: {
      mutate: addToWatchlist,
      loading,
    },
  };
};
